export default "__VITE_ASSET__5e542f46__$_?nuxt_component=async&nuxt_component_name=SvgoEnvelopNew01__"